import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import moment from "moment";


export function ExportExcel(data, temp_int, humid, co2, vibra, powerTension, odometer, initialDate, finalDate) {
    generateSheet(data, temp_int, humid, co2, vibra, powerTension, odometer, initialDate, finalDate)
}

export function ExportExcelFarm(data, temp_int, humid, co2, portaAndAc, initialDate, finalDate) {
    generateSheetFarm(data, temp_int, humid, co2, portaAndAc, initialDate, finalDate)
}

function generateSheet(data, temp_int, humid, co2, vibra, powerTension, odometer, initialDate, finalDate) {

    var jsonData = {}
    let dataSpeed = [];
    let dataIgnition = [];
    let dataThermoKing = [];
    let dataPort = [];
    let speed = [];
    let ignition = [];
    let thermoKing = [];
    let port = [];



    dataSpeed = data.sensorsData.filter(i => i.sensorName === 'Speed');
    dataIgnition = data.sensorsData.filter(i => i.sensorName === 'Ignition');
    dataThermoKing = data.sensorsData.filter(i => i.sensorName === "ThermoKing");
    dataPort = data.sensorsData.filter(i => i.sensorName === "Port");

    dataSpeed.map((i) => {
        speed.push(i.sensorValue);
    });


    dataIgnition.map((i) => {
        ignition.push(i.sensorValue.startsWith("1") ? "Ligada" : "Desligada");
    });

    dataThermoKing.map((i) => {
        thermoKing.push(i.sensorValue === "ON" ? "Ligada" : "Desligada");
    });

    dataPort.map((i) => {
        port.push(i.sensorValue === "True" ? "Fechada" : "Aberta");
    });


    let formattedDate = [];
    temp_int.labels.forEach(element => {
        formattedDate.push(moment(element).format("DD/MM/YYYY HH:mm:ss"));
    });

    const date = formattedDate;
    const latitude = temp_int.lat;
    const longitude = temp_int.lng;
    let listInt1 = [];
    let listInt2 = [];
    let listExt = [];
    let listHumd1 = [];
    let listHumd2 = [];
    let listCO1 = [];
    let listVibra1 = [];
    let listPowerTension = [];
    let listSpeed = [];
    let listThermoKing = [];
    let listPort = [];
    let listIgnition = [];
    let listOdometer = [];
    listInt1 = getListSensorsOrganized(temp_int.sensor1Values);
    listInt2 = getListSensorsOrganized(temp_int.sensor2Values);
    listExt = getListSensorsOrganized(temp_int.sensor3Values);
    listHumd1 = getListSensorsOrganized(humid.sensor1Values);
    listHumd2 = getListSensorsOrganized(humid.sensor2Values);
    listCO1 = getListSensorsOrganized(co2.sensor1Values);
    listVibra1 = getListSensorsOrganized(vibra.sensor1Values);
    listPowerTension = getListSensorsOrganized(powerTension.sensor1Values);
    listSpeed = getListSensorsOrganized(speed);
    listThermoKing = getSecondListSensorsOrganized(temp_int.sensor1Values, thermoKing);
    listPort = getSecondListSensorsOrganized(temp_int.sensor1Values, port);
    listIgnition = getSecondListSensorsOrganized(temp_int.sensor1Values, ignition);
    listOdometer = getListSensorsOrganized(odometer.sensor1Values);

    jsonData[1] =
    {
        'Data': 'Data',
        'Latitude': 'Latitude',
        'Longitude': 'Longitude',
        'Temp P': 'Temp P',
        'Temp S': 'Temp S',
        'Temp E': 'Temp E',
        'Umid P': 'Umid P',
        'Umid S': 'Umid S',
        'CO2': 'CO2',
        'Vibração': 'Vibração',
        'Tensão da Bateria': 'Tensão da Bateria',
        'Climatização': 'Climatização',
        'Porta': 'Porta',
        'Velocidade': 'Velocidade',
        'Ignição': 'Ignição',
        "Odômetro": "Odômetro",

    };

    jsonData[2] =
    {
        'Data': date[0],
        'Latitude': latitude[0],
        'Longitude': longitude[0],
        'Temp P': listInt1[0],
        'Temp S': listInt2[0],
        'Temp E': listExt[0],
        'Umid P': listHumd1[0],
        'Umid S': listHumd2[0],
        'CO2': listCO1[0],
        'Vibração': listVibra1[0],
        'Tensão da Bateria': listPowerTension[0],
        'Climatização': listThermoKing[0],
        'Porta': listPort[0],
        'Velocidade': listSpeed[0],
        'Ignição': listIgnition[0],
        'Odômetro': listOdometer[0],

    };
    jsonData[3] =
    {
        'Data': date[1],
        'Latitude': latitude[1],
        'Longitude': longitude[1],
        'Temp P': listInt1[1],
        'Temp S': listInt2[1],
        'Temp E': listExt[1],
        'Umid P': listHumd1[1],
        'Umid S': listHumd2[1],
        'CO2': listCO1[1],
        'Vibração': listVibra1[1],
        'Tensão da Bateria': listPowerTension[1],
        'Climatização': listThermoKing[1],
        'Porta': listPort[1],
        'Velocidade': listSpeed[1],
        'Ignição': listIgnition[1],
        'Odômetro': listOdometer[1],

    };
    for (var i = 2; i <= listInt1.length; i++) {

        jsonData[i + 2] =
        {
            'Data': date[i],
            'Latitude': latitude[i],
            'Longitude': longitude[i],
            'Temp P': listInt1[i],
            'Temp S': listInt2[i],
            'Temp E': listExt[i],
            'Umid P': listHumd1[i],
            'Umid S': listHumd2[i],
            'CO2': listCO1[i],
            'Vibração': listVibra1[i],
            'Tensão da Bateria': listPowerTension[i],
            'Climatização': listThermoKing[i],
            'Porta': listPort[i],
            'Velocidade': listSpeed[i],
            'Ignição': listIgnition[i],
            'Odômetro': listOdometer[i],

        };

    }



    const distanciaRoute = (parseInt(listOdometer[listOdometer.length - 1]) - parseInt(listOdometer[0])) / 1000;
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;chartset=UTF-8';
    const jsonDataArray = Object.values(jsonData);
    const ws = XLSX.utils.json_to_sheet(jsonDataArray);

    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 15 } }];
    ws['A1'].v = `${data.vehiclePlate} - ${initialDate} até ${finalDate} Distância percorrida no período: ${distanciaRoute.toFixed(2).toString().replace('.', ',')} km`;

    const jsonDataRows = jsonDataArray.map(row => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, jsonDataRows, { origin: -1, skipHeader: false });

    ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: jsonDataRows.length, c: jsonDataRows[0].length } });
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataXLSX = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataXLSX, 'file.xlsx');
}


function generateSheetFarm(data, temp_int, humid, co2, portaAndAc, initialDate, finalDate) {

    var jsonData = {}

    const date = temp_int.labels;
    const latitude = temp_int.lat;
    const longitude = temp_int.lng;
    let listInt1 = [];
    let listInt2 = [];
    let listExt = [];
    let listHumd1 = [];
    let listHumd2 = [];
    let listCO1 = [];
    let listPort = [];
    let listAc = [];

    portaAndAc.sensor3Values.forEach(element => {
        if (element === "False") {
            listPort.push("Porta Aberta");
        } else if (element === "True") {
            listPort.push("Porta Fechada");
        } else {
            listPort.push(" ");
        }
    });

    portaAndAc.sensor1Values.forEach(element => {
        if (element === "OFF") {
            listAc.push("Desligado");
        } else if (element === "ON") {
            listAc.push("Ligado");
        } else {
            listAc.push(" ");
        }
    });

    listInt1 = getListSensorsOrganized(temp_int.sensor1Values);
    listInt2 = getListSensorsOrganized(temp_int.sensor2Values);
    listExt = getListSensorsOrganized(temp_int.sensor3Values);
    listHumd1 = getListSensorsOrganized(humid.sensor1Values);
    listHumd2 = getListSensorsOrganized(humid.sensor2Values);
    listCO1 = getListSensorsOrganized(co2.sensor1Values);


    jsonData[0] =
    {
        'Data': 'Data',
        'Latitude': 'Latitude',
        'Longitude': 'Longitude',
        'Temp P': 'Temp P',
        'Temp S': 'Temp S',
        'Temp E': 'Temp E',
        'Umid P': 'Umid P',
        'Umid S': 'Umid S',
        'CO2 P': 'CO2 P',
        'Porta Fechada': 'Porta',
        'Ar-Condicionado Ligado': 'Ar-Condicionado Ligado',
        'Alarme': 'Alarme',

    };

    for (var i = 1; i <= listInt1.length; i++) {

        jsonData[i] =
        {
            'Data': moment(date[i]).format('DD/MM HH:mm:ss'),
            'Latitude': latitude[i],
            'Longitude': longitude[i],
            'Temp P': listInt1[i],
            'Temp S': listInt2[i],
            'Temp E': listExt[i],
            'Umid P': listHumd1[i],
            'Umid S': listHumd2[i],
            'CO2 P': listCO1[i],
            'Porta Fechada': listPort[i],
            'Ar-Condicionado Ligado': listAc[i],
            'Alarme': data.alarms.reduce((acc, j) => {
                if (moment(j.dtEvent).format('DD/MM HH:mm:ss') === date[i]) {
                    acc.push(j.sensorName);
                }
                return acc;
            }, []).join('/'),
        };

    }




    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;chartset=UTF-8';
    const jsonDataArray = Object.values(jsonData);
    const ws = XLSX.utils.json_to_sheet(jsonDataArray);

    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 11 } }];
    ws['A1'].v = `${data.vehiclePlate} - ${initialDate} até ${finalDate}`;

    const jsonDataRows = jsonDataArray.map(row => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, jsonDataRows, { origin: -1, skipHeader: false });

    ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: jsonDataRows.length, c: jsonDataRows[0].length } });
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataXLSX = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataXLSX, 'file.xlsx');
}

function getListSensorsOrganized(list) {

    let newListOrganized = []
    list.forEach(element => {
        if (isNaN(element)) {
            newListOrganized.push(" ");
        } else {
            newListOrganized.push(element);
        }

    });

    return newListOrganized;
}

function getSecondListSensorsOrganized(list, secondList) {

    let newListOrganized = []
    for (let i = 0; i < list.length; i++) {
        if (isNaN(list[i])) {
            newListOrganized.push(" ");
        } else {
            newListOrganized.push(secondList[i]);
        }
    }

    return newListOrganized;
}